import { RootState } from '../../../../reducers'
import { initialState, MediaSliceState } from './slice'

const mediaSliceSelector = (state: RootState): MediaSliceState => {
  return state.dock?.sections?.media ?? initialState
}

export function scrollTopPxSelector(state: RootState): number {
  return mediaSliceSelector(state).scrollTopPx
}
